module.exports = __webpack_public_path__ + "static/img/message2.a219438.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/message2.png
// module id = wQk/
// module chunks = 1